import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import TaxRatesContainer from "./TaxRatesList";

const TaxRates = () => {
    return (
        <Fragment>
            <TaxRatesContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default TaxRates;